<template>
    <main-layout>
        <!-- Bandeau dégradé + header -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <header class="text-white pt-4 pb-12 px-4 flex items-center justify-between">
                <!-- Titre + retour -->
                <h1 class="text-2xl flex items-center gap-3">
                    <router-link
                        class="inline-flex items-center justify-center h-10 w-10 rounded-lg bg-white/15 hover:bg-white/25 transition"
                        :to="{ name: 'liste-bouteilles' }">
                        <i class="inline-block h-12 w-12 mask mask-arrow-left bg-white"></i>
                    </router-link>
                    <span>Ajout bouteille</span>
                </h1>

                <!-- Bouton Infos bouteille -->
                <button v-if="urlAdmin !== undefined" @click.prevent="generatePopup()"
                    class="bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition">
                    Infos bouteille
                </button>
            </header>
        </div>

        <!-- Corps avec arrondi haut + dégradé clair -->
        <main class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl">
            <div class="m-2 shadow-2xl rounded-lg overflow-hidden mb-24">

                <!-- Carte formulaire -->
                <div class="bg-white p-4">
                    <form class="space-y-4" @submit.prevent="sendForm">
                        <h2 class="text-lg font-medium mb-5 uppercase text-secondary">
                            Informations de la bouteille
                        </h2>

                        <!-- OTAG si présent dans l'URL -->
                        <div v-if="$route.query.key1 && $route.query.key2 && bouteille">
                            <label class="label">
                                OTAG <span class="text-alert">*</span>
                            </label>
                            <input title="otag" type="text" :value="$route.query.key1 + '-' + $route.query.key2"
                                readonly class="input" />
                        </div>

                        <!-- CODE + SCAN -->
                        <div>
                            <label class="label">
                                CODE BOUTEILLE
                                <span class="text-alert ml-1">(CODE BARRE CONSEILLÉ)</span>
                            </label>

                            <div class="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
                                <input id="add_bottle_barcode" title="code" placeholder="Code bouteille" type="text"
                                    v-model.trim="bouteille.code" maxlength="255" class="flex-1 input" />

                                <!-- Lien deep-link conservé + style bouton -->
                                <a href="fi360://scan?success=fillCodeBarre&type=bouteille" id="barcode-scan"
                                    class="inline-flex items-center gap-2 bg-secondary text-white px-4 py-3 rounded-lg hover:opacity-95 transition">
                                    <i class="inline-block h-6 w-6 mask mask-scan-barcode bg-white"></i>
                                    SCAN CODE BARRE
                                </a>
                            </div>
                        </div>

                        <!-- Grille 2 colonnes md+ -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
                            <!-- TYPE -->
                            <div>
                                <label class="label">TYPE DE BOUTEILLE <span class="text-alert">*</span></label>
                                <select v-model="bouteille.type" @change="changeType" class="input">
                                    <option selected disabled>Sélectionnez un type de bouteille</option>
                                    <option>Fluide frigorigène</option>
                                    <option>Récupération</option>
                                    <option>Transfert</option>
                                </select>
                            </div>

                            <!-- DISTRIBUTEUR -->
                            <div>
                                <label class="label">DISTRIBUTEUR <span class="text-alert">*</span></label>
                                <select v-model="bouteille.fournisseur" class="input">
                                    <option selected disabled>Sélectionnez un fournisseur</option>
                                    <option v-for="fournisseur in fournisseurs" :key="fournisseur.id"
                                        :value="fournisseur">
                                        {{ fournisseur.nom }}
                                    </option>
                                </select>
                            </div>

                            <!-- NOM BOUTEILLE -->
                            <div>
                                <label class="label">NOM BOUTEILLE <span class="text-alert">*</span></label>
                                <select v-model="bouteille.nom" @change="changeNomBouteille" id="nomBouteille"
                                    class="input">
                                    <option class="opt-nombout" v-for="n in noms_bouteille" :key="n.id" :value="n"
                                        :class="[n.volume_max !== null ? '' : 'nomax', n.id === 53 ? 'bouteilleID53' : '']"
                                        :data-id="n.id">
                                        {{ n.nom }}
                                    </option>
                                </select>
                            </div>

                            <!-- FLUIDE -->
                            <div>
                                <label class="label">FLUIDE FRIGORIGÈNE <span class="text-alert">*</span></label>
                                <select v-model="bouteille.fluide" ref="selecfluide" class="input">
                                    <option value="" disabled selected>Sélectionnez un fluide frigorigène</option>
                                    <option :value="0" ref="undefinedFluide" disabled>Indéfini</option>
                                    <option v-for="fluide in fluides" :key="fluide.id" :value="fluide"
                                        v-if="fluide.type !== 'CFC' && fluide.type !== 'HCFC' && fluide.nom !== 'R-999'">
                                        {{ fluide.nom }}{{ (fluide.nom_commercial) ? ' - ' + fluide.nom_commercial :
                                        ''}}
                                    </option>
                                </select>
                            </div>

                            <!-- POIDS NET -->
                            <div>
                                <label class="label">POIDS TOTAL DE FLUIDE <span class="text-alert">*</span></label>
                                <div v-if="recommandationPoids" style="margin-top: -8px; margin-bottom: 8px; font-size: 0.85rem; color: #999; font-style: italic;">
                                    Le distributeur préconise {{ recommandationPoids.poidNet }} kg,
                                    <a href="#" @click.prevent="appliquerRecommandationPoids" style="color: #3490dc; text-decoration: underline; cursor: pointer; font-style: italic;">Cliquez pour remplir cette valeur !</a>
                                </div>
                                <input title="poidsNet" type="number" step="0.001" ref="poidsNet"
                                    v-model.number="bouteille.poids_net" @change="changePoidsNet" inputmode="decimal"
                                    class="input" />
                            </div>

                            <!-- Champ caché poids_max conservé -->
                            <input type="hidden" v-model.number="bouteille.poids_max" />

                            <!-- TARE -->
                            <div>
                                <label class="label">TARE</label>
                                <input title="tare" type="number" step="0.001" v-model.number="bouteille.tare"
                                    inputmode="decimal" class="input" />
                            </div>

                            <!-- RÉF LIVRAISON -->
                            <div>
                                <label class="label">RÉFÉRENCE LIVRAISON</label>
                                <input title="ref" type="text" v-model.trim="bouteille.ref_livraison" class="input" />
                            </div>

                            <!-- DATE LIVRAISON -->
                            <div>
                                <label class="label">DATE LIVRAISON <span class="text-alert">*</span></label>
                                <input title="dateLivraison" type="date" :max="now" v-model="bouteille.date_livraison"
                                    @change="calcRetour($event)" class="input" />
                            </div>

                            <!-- DATE RETOUR -->
                            <div>
                                <label class="label">DATE DE RETOUR PRÉVU <span class="text-alert">*</span></label>
                                <input title="dateRetour" type="date" :min="now" v-model="bouteille.date_retour_prevue"
                                    @change="setDateRetour($event)" class="input" />
                            </div>
                        </div>

                        <!-- Submit -->
                        <button type="submit"
                            class="w-full sm:w-auto bg-primary text-white font-semibold tracking-wide px-5 py-3 rounded-xl shadow hover:shadow-md active:scale-[0.99] transition">
                            AJOUTER
                        </button>
                    </form>
                </div>
            </div>
        </main>
    </main-layout>
</template>
<script>

import Bouteille from '../../js/models/Bouteille'
import Fluide from '../../js/models/Fluide'
import NomsBouteille from '../../js/models/NomBouteille'
import Fournisseur from '../../js/models/Fournisseur'
import Scan from '../../js/models/Scan'
import Config from '../../js/config'
import User from "@/js/models/User";
import swal from "sweetalert2";
import localforage from "localforage";

export default {

    data() {
        return {

            bouteille: {
                code: null,
                key1: null,
                key2: null,
                type: null,
                fournisseur: null,
                nom: null,
                fluide: null,
                poids_net: null,
                poids_max: null,
                tare: null,
                ref_livraison: null,
                date_livraison: null,
                date_retour_prevue: null,
                created_at: null
            },

            fournisseurs: [],
            noms_bouteille: [],
            fluides: [],
            notifType: '(Code barre conseillé)',
            urlAdmin: Config.urlAdmin,
            informationBouteille: []
        }
    },

    methods: {
        async sendForm() {

            let bout = this.checkForm();

            if (bout !== false) {

                let checkCode = await this.codeUsed(bout);
                let checkOtag = await this.otagUsed(bout);

                if (!checkCode && !checkOtag) {

                    try {

                        let res = await Bouteille.addBouteille(bout);

                        if (this.$route.query.scan) {

                            try {

                                await Scan.addOfflineScanBouteille(res);

                                this.$router.push('liste-bouteilles');
                                swal('Bouteille ajoutée', 'votre bouteille a bien été ajoutée', 'success')

                            } catch (err) {

                                this.$router.push('liste-bouteilles');
                                swal('Bouteille ajoutée', "votre bouteille a bien été ajoutée mais le scan position n'a pas fonctionné, vérifiez les permissions de l'application", 'success')

                            }


                        } else {

                            this.$router.push('liste-bouteilles');
                            swal('Bouteille ajoutée', 'votre bouteille a bien été ajoutée', 'success')

                        }

                    } catch (err) {
                        swal("Erreur d'ajout", "votre bouteille n'a pas été ajoutée", 'error')

                    }

                }

            }

        },
        checkForm() {

            if (this.$route.query.key1 && this.$route.query.key2) {
                this.bouteille.key1 = parseInt(this.$route.query.key1);
                this.bouteille.key2 = parseInt(this.$route.query.key2);
                this.bouteille.otag = `${this.$route.query.key1}-${this.$route.query.key2}`;
            }

            this.bouteille.created_at = moment().format('YYYY-MM-DD HH:mm:ss');

            let bout = Object.assign({}, this.bouteille);
            let errors = [];

            //null venant du téléphone si on fait retour sur l'appareil photo
            if (!bout.code || bout.code === "null") {
                errors.push("le code")
            }
            if (!bout.type) {
                errors.push("le type de bouteille")
            }
            if (!bout.fournisseur) {
                errors.push("le distributeur")
            }
            if (!bout.nom) {
                errors.push("le nom bouteille")
            }
            if (!bout.fluide && bout.type === 'Fluide frigorigène') {
                errors.push("le fluide")
            }
            if (bout.poids_net === null || bout.poids_net === "") {
                errors.push("le poids total de fluide")
            }
            if (bout.type === 'Fluide frigorigène' && bout.poids_net === 0) {
                errors.push('Une bouteille de fluide frigorigène ne peut pas avoir un poids total de fluide de 0Kg')
            }
            if (!bout.date_livraison) {
                errors.push("la date de livraison")
            }
            if (!bout.date_retour_prevue) {
                errors.push("la date de retour prévue")
            }

            if (errors.length !== 0) {

                let txt = errors.join(', ');
                swal('Information(s) manquante(s) :', 'Veuillez renseigner ' + txt + '.', 'error');
                return false

            } else {

                return bout

            }

        },

        async generatePopup() {
            let token = await localforage.getItem('api-token');

            let html = '';

            html = `
                        <style>
                            .pdf-button {
                                display: block;
                                padding: 12px 20px;
                                margin: 10px auto;
                                border: none;
                                background-color: #3490dc;
                                color: white;
                                font-size: 16px;
                                text-align: center;
                                border-radius: 8px;
                                text-decoration: none;
                                transition: background-color 0.3s ease;
                                width: 80%;
                                max-width: 300px;
                            }
                            .pdf-button:hover {
                                background-color: #2779bd;
                            }
                        </style>
                    `

            let listPdf = [
                { "CALORIE FLUOR": "BOUTEILLES_CALORIE_FLUOR" },
                { "CLIMALIFE": "BOUTEILLES_CLIMALIFE" },
                { "COFRISET": "BOUTEILLES_COFRISET" },
                { "ENTALPIA": "BOUTEILLES_ENTALPIA" },
                { "FRAMACOLD": "BOUTEILLES_FRAMACOLD" },
                { "FRITEC": "BOUTEILLES_FRITEC" },
                { "GASCO": "BOUTEILLES_GASCO" },
                { "GAZECHIM": "BOUTEILLES_GAZECHIM" },
                { "ROLESCO": "BOUTEILLES_ROLESCO" },
                { "WESTFALEN": "BOUTEILLES_WESTFALEN" }
            ];

            listPdf.forEach((element) => {
                const [name, file] = Object.entries(element)[0];
                html += `<a class="pdf-button" style="background-color: #393c51;" href="${this.urlAdmin}/tutorials/infoBouteille?token=${token}&name=${file}" target="_blank">${name}</a>`;
            })


            await swal({
                title: 'Marques bouteilles',
                showConfirmButton: false,
                html
            })

        },

        async codeUsed(bout) {

            let codeUsed = JSON.parse(await localforage.getItem('listBouteilles')).filter(bouteille => {
                if (bouteille.code.toUpperCase() === bout.code.toUpperCase() && bouteille.restitution === false) {
                    return bouteille
                }
            });

            if (codeUsed.length !== 0) {
                swal('Code utilisé', "Ce code bouteille est déjà assigné à une bouteille non rendue", 'error')
            }

            return codeUsed.length !== 0

        },
        async otagUsed(bout) {

            let otagUsed = JSON.parse(await localforage.getItem('OTAGS')).indexOf(bout.key1 + '-' + bout.key2);

            if (otagUsed !== -1) {
                swal('O-TAG utilisé', "Cet O-TAG a déjà été utilisé (" + bout.key1 + '-' + bout.key2 + ")", 'error')
            }

            return otagUsed !== -1

        },
        async initDefaultData() {

            let fournisseur = new Fournisseur;
            let noms = new NomsBouteille;
            let fluide = new Fluide;

            fluide.getListFiltre(data => this.fluides = data);
            noms.getList(data => this.noms_bouteille = data);
            fournisseur.getList(data => this.fournisseurs = data);

            try {
                const infoBouteilleData = await localforage.getItem('informationBouteille');
                if (infoBouteilleData) {
                    this.informationBouteille = JSON.parse(infoBouteilleData);
                }
            } catch (err) {
                console.error('Erreur lors du chargement des informations bouteille:', err);
            }

            if (this.$route.query.key1 && this.$route.query.key2) {

                this.bouteille.code = this.$route.query.key1 + this.$route.query.key2

                if (typeof this.$route.query.type !== "undefined") {
                    this.bouteille.type = this.$route.query.type;


                    if (typeof this.$route.query.code != "undefined" && this.$route.query.code !== 'null') {
                        this.bouteille.code = this.$route.query.code
                    } else if (this.bouteille.type !== "Fluide frigorigène") {
                        this.bouteille.code = null;
                    }

                    this.changeType();
                }

                if (typeof this.$route.query.wantScan !== "undefined") {
                    let btnScanCode = document.getElementById('barcode-scan');

                    btnScanCode.click()
                }


            }

        },
        changeType() {
            let bouteilleID53 = document.querySelector('.bouteilleID53');

            if (bouteilleID53 === null) {
                setTimeout(() => {
                    let bt53 = document.getElementById('nomBouteille').getElementsByClassName('bouteilleID53');
                    bouteilleID53 = bt53[0];

                    if (this.bouteille.type === "Fluide frigorigène") {
                        bouteilleID53.style.display = 'none';

                        let boutmax = document.querySelectorAll('.opt-nombout.nomax');
                        _.forEach(boutmax, bout => {
                            bout.disabled = false;
                            bout.style.display = 'block'
                        })
                    } else {
                        bouteilleID53.style.display = 'block';

                        let boutmax = document.querySelectorAll('.opt-nombout.nomax');
                        _.forEach(boutmax, bout => {
                            bout.disabled = true;
                            bout.style.display = 'none'
                        })
                    }

                }, 500)
            }

            if (this.bouteille.type === "Fluide frigorigène") {

                this.$refs.undefinedFluide.disabled = true;
                this.$refs.undefinedFluide.style.display = 'none';
                this.bouteille.fluide = null;
                this.$refs.selecfluide.disabled = false;
                this.bouteille.poids_net = '';
                this.bouteille.nom = null;
                this.$refs.poidsNet.readOnly = false;

            } else {

                this.$refs.undefinedFluide.disabled = false;
                this.$refs.undefinedFluide.style.display = 'block';
                this.bouteille.fluide = 0;
                this.$refs.selecfluide.disabled = true;
                this.bouteille.poids_net = 0;
                this.bouteille.poids_max = null;
                this.bouteille.nom = null;
                this.$refs.poidsNet.readOnly = true;

            }

            if (bouteilleID53 != null) {
                if (this.bouteille.type === "Fluide frigorigène") {
                    bouteilleID53.style.display = 'none';

                    let boutmax = document.querySelectorAll('.opt-nombout.nomax');
                    _.forEach(boutmax, bout => {
                        bout.disabled = false;
                        bout.style.display = 'block'
                    })
                } else {
                    bouteilleID53.style.display = 'block';

                    let boutmax = document.querySelectorAll('.opt-nombout.nomax');
                    _.forEach(boutmax, bout => {
                        bout.disabled = true;
                        bout.style.display = 'none'
                    })
                }
            }
        },
        changePoidsNet() {
            if (this.bouteille.type === "Fluide frigorigène") {

                if (this.recommandationPoids) {
                    const poidsPreconise = parseFloat(this.recommandationPoids.poidNet);
                    if (poidsPreconise <= this.bouteille.poids_net) {
                        swal('Attention', 'Le poids renseigné ne semble pas être un poids Net de fluide !', 'info');
                    }
                }

                this.bouteille.poids_max = this.bouteille.poids_net
            }
        },
        changeNomBouteille() {
            if (this.bouteille.type !== "Fluide frigorigène" && _.has(this.bouteille.nom, 'volume_max')) {
                this.bouteille.poids_max = this.bouteille.nom.volume_max
            }
        },
        calcRetour(event) {
            this.bouteille.date_livraison = event.target.value;

            if (!this.bouteille.date_retour_prevue && this.bouteille.type) {
                let dateRetour = moment(this.bouteille.date_livraison);
                if (_.includes(this.bouteille.type, 'Fluide')) {
                    dateRetour.add(12, 'month')
                } else {
                    dateRetour.add(6, 'month')
                }
                this.bouteille.date_retour_prevue = dateRetour.format('YYYY-MM-DD')
            }
        },
        setDateRetour(event) {
            this.bouteille.date_retour_prevue = event.target.value;

            if (!this.bouteille.date_retour_prevue && this.bouteille.type) {
                let dateRetour = moment(this.bouteille.date_livraison);
                if (_.includes(this.bouteille.type, 'Fluide')) {
                    dateRetour.add(12, 'month')
                } else {
                    dateRetour.add(6, 'month')
                }
                this.bouteille.date_retour_prevue = dateRetour.format('YYYY-MM-DD')
            } else if (this.bouteille.date_retour_prevue) {
                let dateRetour = moment(this.bouteille.date_retour_prevue);
                this.bouteille.date_retour_prevue = dateRetour.format('YYYY-MM-DD')
            }
        },

        appliquerRecommandationPoids() {
            if (this.recommandationPoids && this.recommandationPoids.poidNet !== null && this.recommandationPoids.poidNet !== undefined) {
                this.bouteille.poids_net = this.recommandationPoids.poidNet;
                this.changePoidsNet();
            }
        }
    },

    mounted: function () {
        this.initDefaultData();
    },

    computed: {
        now: function () {
            return moment().format('Y-MM-DD')
        },

        recommandationPoids() {
            // Vérifier le type de bouteille en premier (on cherche seulement pour "Fluide frigorigène")
            if (!this.bouteille.type || this.bouteille.type !== 'Fluide frigorigène') {
                return null;
            }

            // Vérifier que tous les autres champs nécessaires sont remplis
            if (!this.bouteille.fournisseur ||
                !this.bouteille.nom ||
                !this.bouteille.fluide ||
                !Array.isArray(this.informationBouteille) ||
                this.informationBouteille.length === 0) {
                return null;
            }

            const marque = this.bouteille.fournisseur.nom;
            const nomBouteille = this.bouteille.nom.nom;
            const fluideNom = this.bouteille.fluide.nom;
            // Détecter si c'est un fluide régénéré (format: "R-404A R - Régénéré" ou propriété regenerated)
            const isFluideRegenere = this.bouteille.fluide.regenerated === true ||
                                     (fluideNom && (fluideNom.includes('Régénéré') || fluideNom.includes('Régéné')));

            const correspondance = this.informationBouteille.find(info => {
                // Comparer la marque (fournisseur)
                const marqueMatch = info.marque && marque &&
                    info.marque.toUpperCase().trim() === marque.toUpperCase().trim();

                // Comparer le nom de bouteille
                const nomMatch = info.nomBouteille && nomBouteille &&
                    info.nomBouteille.toUpperCase().trim() === nomBouteille.toUpperCase().trim();

                // Comparer le fluide (gérer les fluides régénérés)
                let fluideMatch = false;
                if (info.fluide && fluideNom) {
                    const infoFluideUpper = info.fluide.toUpperCase().trim();
                    const fluideNomUpper = fluideNom.toUpperCase().trim();

                    // Extraire le nom de base (enlever " R", "R", " R - Régénéré", etc.)
                    const getFluideBase = (fluide, isRegenere = false) => {
                        let base = fluide.replace(/\s+R\s*-\s*R[ÉE]G[ÉE]N[ÉE]R[ÉE]?/i, '').trim();
                        base = base.replace(/\s+R$/i, '').trim();
                        if (isRegenere) {
                            base = base.replace(/([A-Z0-9])R$/i, '$1').trim();
                        }
                        return base;
                    };

                    const infoIsRegenere = /[A-Z0-9]R$/i.test(infoFluideUpper);
                    const fluideNomBase = getFluideBase(fluideNomUpper, isFluideRegenere);
                    const infoFluideBase = getFluideBase(infoFluideUpper, infoIsRegenere);

                    // Correspondance exacte
                    fluideMatch = infoFluideUpper === fluideNomUpper;

                    // Si pas de correspondance exacte, comparer les noms de base
                    if (!fluideMatch) {
                        fluideMatch = fluideNomBase === infoFluideBase && fluideNomBase !== '';
                    }
                }

                // Vérifier que le typeBouteille correspond
                // Pour fluide régénéré : "FLUIDE Régénéré" uniquement
                // Pour fluide normal : "FLUIDE" mais pas "RÉGÉNÉRÉ"
                let typeMatch = false;
                if (info.typeBouteille) {
                    const typeBouteilleUpper = info.typeBouteille.toUpperCase();

                    if (isFluideRegenere) {
                        // Pour fluide régénéré, chercher "FLUIDE Régénéré", "FLUIDE" seul, ou "TRANSFERT"
                        typeMatch = (typeBouteilleUpper.includes('FLUIDE') && typeBouteilleUpper.includes('RÉGÉNÉRÉ')) ||
                                   typeBouteilleUpper === 'FLUIDE' ||
                                   typeBouteilleUpper === 'TRANSFERT';
                    } else {
                        // Pour fluide normal, chercher "FLUIDE" mais pas "RÉGÉNÉRÉ"
                        typeMatch = typeBouteilleUpper.includes('FLUIDE') &&
                                   !typeBouteilleUpper.includes('RÉGÉNÉRÉ');
                    }
                }

                const poidsNetOk = info.poidNet !== null && info.poidNet !== undefined;

                return marqueMatch && nomMatch && fluideMatch && typeMatch && poidsNetOk;
            });

            return correspondance || null;
        }
    }

}

</script>

<style scoped>
/* Couleurs d’alerte pour le span (équiv. exemple) */
.text-alert {
    color: #c31616;
}
</style>



// WEBPACK FOOTER //
// NewBouteille.vue?6478dfe2